<template>
  <div class="shopMallBox">
    <div class="shopMallTitle">
      <div :class="['title',tabType ==item.type?'isTitle':'']" v-for="(item,index) in tradeImgData" :key="index" @click="handleTradeTitle(item,index)">
        <span>{{item.name}}</span>
        <i></i>
      </div>
    </div>
    <div class="shopMallBg">
      <div class="shopMallTabBox">
        <el-card class="shopMallGoods" v-for="(item,index) in tableData" :key="index">
          <div class="shopMallGoodsImgBox">
            <el-image :src="(tabType == 'da'?item.goodsCover?$store.state.file_url+item.goodsCover:'':item.cover?$store.state.file_url+item.cover:'')">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <el-tooltip effect="dark" :content="(tabType == 'da'?item.goodsName:item.name)" placement="top-start">
            <p class="goodsTitle">{{(tabType == 'da'?item.goodsName:item.name)}}</p>
          </el-tooltip>
          <span class="goodsPrice">{{(tabType == 'da'?item.projectType:item.price/100)}}</span>
        </el-card>
        <el-pagination background prev-text="上一页" next-text="下一页" @current-change="handleCurrentChange" :current-page="listQuery.currentPage" :page-size="listQuery.pageSize" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      shopName: '0',
      total: 0,
      listQuery: {
        pageSize: 10,
        currentPage: 1
      },
      tradeImgData: [],
      tableData: [],
      tabType: 'da',
    }
  },
  created() {
    this.tabType = this.$route.query.type;
    this.getGoodsList();
    this.getTradData();
  },
  methods: {
    getTradData() {
      this.$axiosPost(this.$store.state.shop_url + "/category/list", {

      }).then(res => {
        if (res.code == 200) {
          this.tradeImgData = res.data.ptCategoryList;
        }
      })
    },
    //商品列表
    getGoodsList() {
      const loading = this.loading();
      if (this.tabType == 'da') {
        let goods = {
          isDigitalAssets: 1,
          pageSize: this.listQuery.pageSize,
          currentPage: this.listQuery.currentPage
        }
        this.$axiosPost(this.$store.state.shop_url + "/goods/batch/list/v2", {
          goods: JSON.stringify(goods)
        }).then(res => {
          loading.close();
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.page.totalRows;
          }
        })
      } else {
        this.$axiosGet(this.$store.state.wptWespce_url + "/zxt/index/list/v7", {
          position: 'gs',
          level: 1,
          pid: 0,
          type:this.tabType,
          pageSize: this.listQuery.pageSize,
          currentPage: this.listQuery.currentPage

        }).then(res => {
          loading.close();
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.page.totalRows;
          }
        })
      }


    },
    handleTradeTitle(item, index) {
      this.tabType = item.type;
      this.listQuery.currentPage = 1;
      this.getGoodsList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val;
      this.getGoodsList()
    }
  }
}
</script>
<style scoped lang="scss">
.shopMallBox {
  background: #f6f7f9;
  .shopMallTitle {
    width: 1210px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .title {
      width: 150px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      position: relative;
      span {
        font-size: 14px;
        color: #666666;
      }
      i {
        position: absolute;
        left: 55px;
        bottom: 4px;
        display: none;
        width: 40px;
        height: 6px;
        background: #232428;
        margin-top: 10px;
      }
    }
    .title:hover {
      cursor: pointer;
      span {
        color: #3d3d3d;
      }
      i {
        display: inline-block;
      }
    }
    .isTitle {
      i {
        display: inline-block !important;
      }
    }
  }
  .shopMallBg {
    background: #fff;
    padding: 20px 0;
    .shopMallTabBox {
      width: 1210px;
      margin: 0 auto;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      .shopMallGoods {
        width: 240px;
        height: 334px;
        background: #ffffff;
        border: 1px solid #f2f2f2;
        box-shadow: none;
        .shopMallGoodsImgBox {
          width: 219px;
          height: 219px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        ::v-deep.el-image,
        ::v-deep.image-slot {
          max-width: 219px;
          max-height: 219px;
        }
        ::v-deep.image-slot {
          background: #f5f7fa;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .goodsTitle {
          height: 38px;
          line-height: 21px;
          margin: 11px 0 14px 0;
          font-size: 14px;
          font-weight: 400;
          color: #181818;
          display: -webkit-box; //谷歌
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; //显示几行
          word-wrap: break-word;
          overflow: hidden;
        }
        .goodsPrice {
          font-size: 20px;
          font-weight: 600;
          font-weight: bold;
          color: #181818;
        }
      }
      .shopMallGoods:hover {
        cursor: pointer;
        box-shadow: 0px 0px 6px 2px rgba(153, 153, 153, 0.2);
        .goodsPrice {
          color: #d74e35;
        }
      }
      ::v-deep.el-card__body {
        padding: 10px;
      }
      ::v-deep.el-pagination {
        margin: 0 auto;
        margin-top: 30px;
        position: relative;
        .btn-prev,
        .btn-next {
          padding: 0 12px;
        }
        .active {
          background-color: #1C77FF;
        }
        .active:hover {
          color: #fff !important;
        }
        li:hover {
          color: #606266;
        }
      }
    }
  }
  .el-pagination {
    width: 100%;
    text-align: center;
  }
}
</style>
